import React, { ReactNode, useEffect } from 'react';

import Header from '../Layout/Header';
import IntoSectionProjects from '../ProjectHomePage/IntroPage';

interface Props {
  children: ReactNode;
}

const ProductLayout: React.FC<Props> = ({ children }) => {
  const links = [
    { route: '/product/books-list', text: 'Books' },
    { route: '/product/courses-list', text: 'Courses' },
    { route: '/product/bundles-list', text: 'Bundles' },
  ];
  useEffect(() => {
    const handleRouteChange = (url: string) => {
      const sectionId = url?.split('#')[1];
      if (sectionId) {
        const section = document.getElementById(sectionId);
        if (section) {
          const offset = 100;
          const elementPosition =
            section.getBoundingClientRect().top + window?.scrollY;
          const offsetPosition = elementPosition - offset;

          window?.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }
    };
    window?.addEventListener('hashchange', () => {
      handleRouteChange(window?.location.href);
    });

    return () => {
      window?.removeEventListener('hashchange', () => {
        handleRouteChange(window?.location.href);
      });
    };
  }, []);

  return (
    <>
      <div id='products'>
        <IntoSectionProjects />
      </div>
      <div id='resources-container'>
        <Header links={links} isShort={true} heading='All' />
        <div className='px-5 md:px-12 xl:px-24 py-6 md:py-16'>{children}</div>
      </div>
    </>
  );
};

export default ProductLayout;
